import { createAnalytics } from '@reinz/analytics/createAnalytics'

const GA_ID = import.meta.env.VITE_GA_MEASUREMENT_ID as string | undefined

const analytics = createAnalytics({ ga4: GA_ID ? { measurementId: GA_ID } : undefined })

export function initGA() {
  analytics.init()
}

export function setUser(userId: string) {
  analytics.identify({ id: userId, ga4Properties: { imis_id: userId } })
}

export function trackPageView(pageName: string) {
  analytics.page({ path: window.location.pathname, title: pageName })
}

export function trackEvent(
  eventName: string,
  params?: Record<string, string | number | boolean | undefined>,
) {
  analytics.event(eventName, params)
}
